import React, { Component } from "react";
import moment from "moment";
import { Link } from "react-router-dom";
import routes from "../../routes/URL";
import API, { URL_PATH } from "../../services/API";
import redux from "../../common/Redux";
import Table from "../../components/Table";
import Colors from "../../common/Colors";
import Switch from "../../components/Switch";
import Toast from "../../components/Toast";
class ListMenuScreen extends Component {
  constructor(props) {
    super(props);
    this.state = { data: null, active: "details", permissions: [] , toast: {
      open: false,
      message: "",
      severity: "success" 
    }};
  }
  componentDidMount() {
    this.getUserData();
    this.getAllAvailablePermissions();
  }
  showToast = (message, severity = "success") => {
    this.setState({
      toast: {
        open: true,
        message,
        severity
      }
    });
  };

  handleCloseToast = (event, reason) => {
    if (reason === 'clickaway') return;
    this.setState({ toast: { ...this.state.toast, open: false } });
  };

  getAllAvailablePermissions = async () => {
    const { status, message, data } = await API(
      this,
      "get",
      URL_PATH.getAllAvailablePermissions
    );
    if (status == "success") {
      this.setState({ permissions: data });
    } else {
      this.showToast(message, "error");
    }
  };
  getUserData = async () => {
    const { status, message, data } = await API(
      this,
      "get",
      URL_PATH.getUserData(this.props.match.params.id)
    );
    if (status == "success") {
      this.setState({ data });
    } else {
      this.showToast(message, "error");
    }
  };

  onDelete = async (item) => {
    console.log("sure to delete?");
    const { status, message, data } = await API(
      this,
      "post",
      URL_PATH.deleteMenu(item.id)
    );
    if (status == "success") {
      this.showToast(message, "success");
      this.setState({
        version: this.state.version + Math.random() + "",
      });
    } else {
      this.showToast(message, "error");
      console.log("error");
    }
  };
  onEdit = async (item) => {
    this.props.history.push(routes.admin.users.update(item.id));
  };
  onView = async (item) => {
    // this.props.history.push("/floors/" + item.id);
  };

  updateAccess = async (access_controll_id, action) => {
    const user_id = this.props.match.params.id;
    const { status, message, data } = await API(
      this,
      "post",
      URL_PATH.updateUserAccessControl,
      { user_id, access_controll_id, action }
    );

    if (status == "error")
      this.showToast(message, "error");
     
  };
  UserDetails = () => {
    if (this.state.data == null) return null;

    const { id, name, mobile, email } = this.state.data;

    //return form with prefilled value id feild will be disabled

    return (
      <div className="card  mx-4 my-4 py-4  col-12" data-bs-theme="dark">
        <div className="card-header">
          <h5 className="card-title">User Details</h5>
        </div>
        <form
          className="card-body"
          data-bs-theme="dark"
          id="hotelForm"
          name="hotelForm"
          onSubmit={(e) => {
            e.preventDefault();
            return this.create();
          }}
        >
          <div className="form-group">
            <label htmlFor="name">Name</label>
            <input
              type="text"
              className="form-control"
              id="name"
              placeholder="Enter Name"
              value={name}
              onChange={(e) => {
                this.setState({
                  data: {
                    ...this.state.data,
                    name: e.target.value,
                  },
                });
              }}
            />
          </div>

          <div className="form-group">
            <label htmlFor="mobile">Mobile</label>
            <input
              type="text"
              className="form-control"
              id="mobile"
              placeholder="Enter Mobile"
              value={mobile}
              onChange={(e) => {
                this.setState({
                  data: {
                    ...this.state.data,
                    mobile: e.target.value,
                  },
                });
              }}
            />
          </div>

          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              type="text"
              className="form-control"
              id="email"
              placeholder="Enter Email"
              value={email}
              onChange={(e) => {
                this.setState({
                  data: {
                    ...this.state.data,
                    email: e.target.value,
                  },
                });
              }}
            />
          </div>
          {/* Update button */}
          <button
            type="submit"
            className="btn btn-primary"
            style={{ backgroundColor: Colors.primary }}
          >
            Update
          </button>
        </form>
      </div>
    );
  };
  UserPermissions = () => {
    if (this.state.data == null) return null;
    const { access_controls } = this.state.data;
    const { permissions } = this.state;
    // render permissions list with checkbox and prefilled value based on its presense in access_controls
    return (
      <div className="card mx-4 my-4 py-4  col-12 " data-bs-theme="dark">
        <div className="card-header">
          <h5 className="card-title">User Permissions</h5>
        </div>
        <div className="card-body d-flex flex-row justify-content-between flex-wrap">
          {permissions.map((item, index) => {
            return (
              <div className="col-4">
                <div
                  className="form-check  p-3 d-flex flex-row justify-content-between"
                  key={index}
                >
                  <label className="form-check-label" htmlFor={item.id}>
                    {item.name.replace("-", " ")}
                  </label>
                  <div>
                    <Switch
                      className="form-check-input"
                      type="checkbox"
                      value={item.id}
                      id={item.id}
                      checked={
                        access_controls.find((x) => x.id == item.id) !=
                        undefined
                      }
                      onChange={(e) => {
                        if (e) {
                          this.setState({
                            data: {
                              ...this.state.data,
                              access_controls: [
                                ...this.state.data.access_controls,
                                {
                                  id: item.id,
                                },
                              ],
                            },
                          });
                        } else {
                          this.setState({
                            data: {
                              ...this.state.data,
                              access_controls:
                                this.state.data.access_controls.filter(
                                  (x) => x.id != item.id
                                ),
                            },
                          });
                        }

                        this.updateAccess(item.id, e ? "grant" : "revoke");
                      }}
                    />
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  };
  render() {
    return (
      <div className="container">
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            alignContent: "center",
          }}
        >
          <h1>User</h1>
          {/* <div
                        className="btn btn-primary"
                        onClick={() => {
                            this.props.history.push(routes.admin.users.create);
                            // location.history.push("/hotel/create");
                        }}
                    >
                        New User
                    </div> */}
        </div>
        {/* Tabs User details, User Permissions */}

        <div
          className="d-flex flex-row justify-content-center"
          style={{ justifyContent: "center" }}
        >
          <div
            style={{
              padding: "5px 10px",
              backgroundColor: Colors.pageBgColor,
              borderRadius: "3px",
              marginRight: "10px",
              cursor: "pointer",
              // color: "black",
              fontWeight: "bold",
              boxShadow: "0px 0px 10px 0px rgba(0,0,0,0.2)",
              border:
                this.state.active == "details"
                  ? "1px solid " + Colors.primary
                  : "",
            }}
            onClick={() => {
              this.setState({
                active: "details",
              });
            }}
          >
            Details
          </div>
          <div
            onClick={() => {
              this.setState({
                active: "permissions",
              });
            }}
            style={{
              padding: "5px 10px",
              backgroundColor: Colors.pageBgColor,
              borderRadius: "3px",
              marginRight: "10px",
              cursor: "pointer",
              // color: "black",
              fontWeight: "bold",
              boxShadow: "0px 0px 10px 0px rgba(0,0,0,0.2)",
              border:
                this.state.active != "details"
                  ? "1px solid " + Colors.primary
                  : "",
            }}
          >
            Permissions
          </div>
        </div>

        {/* Tab Content*/}

        {this.state.active == "details" && <this.UserDetails />}

        {this.state.active != "details" && <this.UserPermissions />}

        {/* <div className="d-flex flex-column justify-content-center">
                    <this.UserDetails />
                    <this.UserPermissions />
                </div> */}
                  <Toast
        open={this.state.toast.open}
        message={this.state.toast.message}
        severity={this.state.toast.severity}
        onClose={this.handleCloseToast}
      />
      </div>
    );
  }
}

export default redux(ListMenuScreen);
